module.exports = __webpack_public_path__ + "img/p3.01c5fa0c.png";